import { createFileRoute } from '@tanstack/react-router';
import z from 'zod';

import { Art } from '@/view/pages/Decoupages/Art';

export const Route = createFileRoute('/_protected/$programId/decupagens/arte')({
  component: Art,
  validateSearch: z.object({
    numeroCena: z.string().optional().catch(''),
    numeroCapitulo: z.number().optional().catch(0),
  }),
  context: (context): { title: string } => ({
    ...context,
    title: 'Decupagem de Arte',
  }),
});
